import type { InventoryItemDto, InventorySlotDto, User } from '../services/api';

const HEALTH_POTION_KEYS = new Set([
  'SmallHealthPotion',
  'MediumHealthPotion',
  'LargeHealthPotion',
]);

export function isHealthPotionItemKey(itemTypeKey: string): boolean {
  return HEALTH_POTION_KEYS.has(itemTypeKey);
}

function parseUtcIsoMs(iso: string): number {
  const s = iso.trim();
  const hasZone = /Z$/i.test(s) || /[+-]\d{2}:?\d{2}$/.test(s);
  return Date.parse(hasZone ? s : `${s}Z`);
}

function inventoryItemNotExpired(item: InventoryItemDto): boolean {
  if (!item.expiresAtUtc) return true;
  return parseUtcIsoMs(item.expiresAtUtc) > Date.now();
}

export function inventorySlotsHaveUnusedHealthPotion(slots: InventorySlotDto[]): boolean {
  for (const s of slots) {
    const it = s.item;
    if (!it || !isHealthPotionItemKey(it.itemTypeKey)) continue;
    if (inventoryItemNotExpired(it)) return true;
  }
  return false;
}

/**
 * Reminder when the player is at most half full on life units — prompt to use a health potion from inventory.
 * Full lives (current >= maxLives) → no reminder.
 */
export function shouldPromptHealthPotionReminder(user: User | null | undefined): boolean {
  if (!user || typeof user.lives !== 'number') return false;
  const max = user.livesStatus?.maxLives ?? 10;
  if (user.lives >= max) return false;
  return user.lives <= Math.floor(max / 2);
}
